import React from 'react';

export default function useErrorState(initState = undefined) {
  const [state, dispatch] = React.useState(initState);
  const onCatch = React.useCallback((error) => dispatch(error instanceof Error ? error.message : String(error)), []);

  return [state, onCatch, dispatch];
}
